import api from '@/store/api'
import cookies from 'js-cookie'
import { getField, updateField } from 'vuex-map-fields'

export const state = {
    token: cookies.get('token'),
    isLoggedIn: false,
    loading: false,

    email: '',
    password: '',

    error: '',
    forgotPasswordMessage: '',

    newPassword: '',
    confirmPassword: '',
    
    user: null,
}

export const actions = {
    async signIn ({ commit }, payload) {
        state.loading = true
        const { data, message, status } = await api('post', '/cms/authenticate/login', payload)

        if (status) {
            state.user = data.data
            state.token = data.data.api_token
            cookies.set('token', data.data.api_token, { expires: 36500 })
            state.isLoggedIn = true
            
            
            state.loading = false
            location.reload()
            commit('clearAuth')
            return
        }

        state.error = message || 'Something went wrong'
        state.user = null
        cookies.remove('token')
        state.loading = false
        return
    },

    async fetchUser () {
        state.loading = true

        const { status, data } = await api('get', '/cms/admin/view')

        if (status) {
            state.isLoggedIn = true
            state.user = data.data
        } else {
            state.isLoggedIn = false
            state.token = null
            cookies.remove('token')
        }

        state.loading = false
    },

    async forgotPassword ({ commit }, payload) {
        payload.commit = commit
        state.loading = true

        const { data, status } = await api('post', '/cms/authenticate/forgot-password', payload)

        if (status) {
            state.forgotPasswordMessage = 'success'
            state.loading = false
            return
        }
        
        state.forgotPasswordMessage = data.message
        state.loading = false
    },

    async generatePass () {
        state.loading = true

        const { data, status } = await api('post', '/cms/authenticate/generate-password')

        state.loading = false
        return status ? data.data.password : false
    },

	async checkEmail ({ state }, payload) {
		state.loading = true
		const { status } = await api('post', '/cms/client/check-email', payload)

		state.loading = false
		return status
	},

    async signOut () {
        state.isLoggedIn = false
        state.token = ''
        cookies.remove('token')
        location.reload()
    },
}

export const mutations = {
    updateField,

    uploadProgress () {

    },

    clearAuth () {
        state.email = ''
        state.password = ''
        state.error = ''
        state.loading = false
    },


}

const getters = {
    getField
}

export default {
    state,
    actions,
    mutations,
    getters
}